/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
import { getUserAgentId } from '../shared/helper-utils/localStorage';
import { doPost } from './apiUtils';

export const searchCabsCitiesApi = async (searchkey, searchType) => {
  try {
    const request = {
      opid: 'HS000',
      actioncode: 'TRANSFERSEARCHAUTOSUGGEST',
      placeType: searchType,
      agentid: getUserAgentId(),
      searchkey,
    };
    const response = await doPost(request);

    return response;
  } catch (error) {
    return undefined;
  }
};

export const repriceCabsApi = async (req) => {
  try {
    const request = {
      opid: 'HS000',
      actioncode: 'TRANSFERREPRICE',
      agentid: getUserAgentId(),
      data: JSON.stringify(req),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const bookCabsApi = async (req, paymentmode) => {
  try {
    const string = JSON.stringify(req);
    const base64 = btoa(string);
    const request = {
      opid: 'TX047',
      actioncode: 'transferbookingv2',
      agentid: getUserAgentId(),
      data: base64,
      isCustomerbilling: true,
      isenc: true,
      paymentmode,
    };
    const response = await doPost(request);

    return response;
  } catch (error) {
    return undefined;
  }
};

export const searchCabsApi = async (req) => {
  try {
    const request = {
      opid: 'HS000',
      actioncode: 'TRANSFERSEARCH',
      agentid: getUserAgentId(),
      data: JSON.stringify(req),
    };
    const response = await doPost(request);

    return response;
  } catch (error) {
    return undefined;
  }
};
